import {
  Component,
} from "react";
import uiconfig from "CommonState/uiconfig";
import AntragDokumenteSbWidget from "App/antrag-dokumente-sb-widget";
import antragApi from "Apis/antrag-api";
import {
  Spinner,
} from "CommonComponents/bricks";

@uiconfig
@antragApi.current
export default class AntragDokumenteSbTab extends Component {
  render() {
    const { currentAntrag } = this.props;

    if (!currentAntrag) {
      return <Spinner />;
    }
    return <div>
      <AntragDokumenteSbWidget antrag={ currentAntrag } />
    </div>;
  }
}
